// @ts-strict-ignore
import styled from 'styled-components';
import Link from 'next/link';
import { Community } from 'src/constants/types';
import Avatar, { Size } from 'src/components/avatar';
import { titleMedium, text } from 'styles-js/mixins/typography';

const DESKTOP_MAX_LENGTH = 140;
const MOBILE_MAX_LENGTH = 90;

export default function CommunityListItem({ community, isMobile }: { community: Community, isMobile: boolean }): JSX.Element {
  const { name, imageUrl, description, slug } = community;

  const shortenText =  (text: string) => {
    const limit = isMobile ? MOBILE_MAX_LENGTH : DESKTOP_MAX_LENGTH;
    return text.length > limit ? text.slice(0, limit - 1) + '...' : text;
  };

  return (
    <Link
      legacyBehavior
      passHref
      as={`/${slug}`}
      href={`/community/communityHome?communitySlug=${slug}`}
    >
      <Item>
        <Avatar name={name} size={Size.Medium} url={imageUrl} />
        <Text>
          <Title>{name}</Title>
          <Description>{shortenText(description)}</Description>
        </Text>
      </Item>
    </Link>
  );
}

const Item = styled.a`
  display: flex;
  margin-bottom: 20px;
  border-bottom: ${({ theme }) => theme.greyLine};
  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`;

const Title = styled.div`
  ${titleMedium};
`;

const Description = styled.div`
  ${text};
  padding: 20px 0 30px;
`;
